import { Node, findParentNode, mergeAttributes } from '@tiptap/core';
import { DropdownItemName } from './DropdownItem.js';

const DropdownItemContentName = "dropdownItemContent";
const DropdownItemContent = Node.create({
  name: DropdownItemContentName,
  // addNodeView() {
  //   return ({ getPos, editor }) => {
  //     const parent = findParentNode((node) => node.type.name === DropdownItemName)(
  //       NodeSelection.create(editor.state.doc, getPos()),
  //     );
  //     const expanded = parent?.node.attrs.expanded;
  //     console.log(expanded);
  //     const container = document.createElement('div');
  //     const content = document.createElement('div');
  //     container.appendChild(content);
  //     return {
  //       dom: container,
  //       contentDOM: expanded ? content : null,
  //       stopEvent: () => {
  //         return !expanded;
  //       },
  //     };
  //   };
  // },
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "dropdownItem",
  content: "block+",
  parseHTML() {
    return [
      {
        tag: `div[data-node-type="${DropdownItemContentName}"]`
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        ["data-node-type"]: DropdownItemContentName
      }),
      0
    ];
  },
  addKeyboardShortcuts() {
    return {
      Backspace: ({ editor }) => {
        const isActive = editor.isActive(this.name);
        const { $from, from, to } = editor.state.selection;
        const dropdown = findParentNode((node2) => node2.type.name === DropdownItemName)(editor.state.selection);
        const content = findParentNode((node2) => node2.type.name === DropdownItemContentName)(editor.state.selection);
        const node = $from.node();
        if (isActive && $from.start() === from && to === from && node === content?.node.lastChild && node !== content.node.firstChild && !!dropdown) {
          return editor.chain().insertContentAt(dropdown.pos + dropdown.node.nodeSize, node.copy(node.content)).deleteRange({
            from: $from.start() - 1,
            to: $from.end()
          }).selectTextblockStart().run();
        }
        return false;
      }
    };
  }
});

export { DropdownItemContent, DropdownItemContentName };
//# sourceMappingURL=DropdownItemContent.js.map
